export default __webpack_public_path__ + "static/media/whitepapertwo.8250c2b9.png";